import React from 'react';
import { Asset } from 'contentful';

import { IOverlayHeroFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { BlockContainer, Column, Layout } from '../Layout';
import { Box } from '../Box';
import RichText from '../RichText';
import { GlImage } from '../Image';

import { LayoutContainer } from '../Layout/styles';

import {
  NoOverflowBox,
  HeroText,
  MobileHeading,
  DesktopHeading,
  MobileCopyWrapper,
  DesktopCopyWrapper,
  ImageWrapper
} from './styles';

export function OverlayHero({
  headingText,
  copy,
  desktopHeadingText,
  desktopCopy,
  image,
  useLightText,
  desktopImage
}: IOverlayHeroFields) {
  return (
    <BlockContainer
      as="section"
      marginTop="blockMargin"
      marginBottom={{
        0: 'xs',
        tablet: 'blockMarginY_tablet',
        desktop: 'm'
      }}
      revealOnScroll={false}
      data-blockid="overlay-hero"
      data-testid="overlay-hero-block"
      data-e2e="hero"
    >
      <LayoutContainer>
        <NoOverflowBox borderRadius={{ 0: 'block', desktop: 'block_desktop' }}>
          <ImageWrapper>
            <GlImage
              {...getImageData(desktopImage as Asset)}
              loading="eager"
              heroImage={true}
            />
          </ImageWrapper>

          <NoOverflowBox
            id="no-overflow-box"
            borderRadius={{ 0: 'block', desktop: 'block_desktop' }}
          >
            <ImageWrapper isMobile={true}>
              <GlImage
                {...getImageData(image)}
                loading="eager"
                heroImage={true}
              />
            </ImageWrapper>
          </NoOverflowBox>
          <HeroText>
            <Layout
              margin={{ 0: ['ml', 0], tablet: [0, 0] }}
              gutter={{ 0: 'ml', desktop: 0 }}
            >
              <Column size={{ 0: 8, tablet: 10 }} flexDirection="column">
                <Box marginBottom="m">
                  <MobileHeading
                    as="h1"
                    fontWeight="h1"
                    fontSize={{ 0: 'h2_0', desktop: 'h1_tablet' }}
                    colour={{
                      0: 'defaultText',
                      tablet: useLightText ? 'white' : 'defaultText'
                    }}
                    dangerouslySetInnerHTML={{
                      __html: headingText || ''
                    }}
                  />
                  <DesktopHeading
                    as="h1"
                    fontWeight="h1"
                    fontSize={{ 0: 'h1_0', desktop: 'h1_tablet' }}
                    colour={{
                      0: 'defaultText',
                      tablet: useLightText ? 'white' : 'defaultText'
                    }}
                    dangerouslySetInnerHTML={{
                      __html: desktopHeadingText || headingText || ''
                    }}
                  />
                </Box>

                {copy && (
                  <MobileCopyWrapper>
                    <RichText
                      data={copy}
                      colour={{
                        0: 'defaultText',
                        tablet: useLightText ? 'white' : 'defaultText'
                      }}
                    />
                  </MobileCopyWrapper>
                )}
                {(copy || desktopCopy) && (
                  <DesktopCopyWrapper>
                    <RichText
                      data={desktopCopy || copy}
                      colour={{
                        0: 'defaultText',
                        tablet: useLightText ? 'white' : 'defaultText'
                      }}
                    />
                  </DesktopCopyWrapper>
                )}
              </Column>
            </Layout>
          </HeroText>
        </NoOverflowBox>
      </LayoutContainer>
    </BlockContainer>
  );
}
